import AOS from 'aos';

AOS.init({
  once: true
});